
import { useTaskListBatchModeStore } from '@root/src/store/stores/gcb2/taskListBatchMode'
import { useGcb2Store } from '@root/src/store/stores/gcb2/gcb2'
import { useConfirmStore } from '@root/src/store/stores/confirm'
import { computed, defineComponent, getCurrentInstance, onMounted, Ref, ref } from 'vue'
import { storeToRefs } from 'pinia'
import NoOneSelected from '@root/src/components/chisai/GCB2/sidebar/batchMode/NoOneSelected.vue'
import Message from '@root/src/components/chisai/GCB2/sidebar/batchMode/Message.vue'
import { MAKE_TASKLIST_ACTION } from '@root/src/store/chisai/GCB2/actionTypes'
import {
    COMMUNICATION_ERROR_CODES,
    TASKLIST_ACTION_TYPES,
    TASKLIST_COMMUNICATIONS_TYPES,
} from '@root/src/vars/GCB2'
import actions from '@root/src/components/chisai/GCB2/taskList/actions'
import { Project } from '@root/src/types/main'
import messsages from '@dataheroes/messages'
import { Activation, ManualCommunication } from '../../../types/GCB2'
import { ImportantError } from '../../../helpers/Error'
import { useUser } from '../../../hooks/useUser'
import api from '../../../api/api'
import HintIcon from '../../../components/HintIcon.vue'
import { declOfNum } from '../../../utils'
import { useHintStore } from '../../../store/stores/hint'
import checkConnectors from '../../../helpers/functions/checkConnectors'
import * as t from '@/store/chisai/GCB2/taskList/actionTypes'
import { useModalStore } from '@root/src/store/stores/modal'
import { fetchConnector } from '@root/src/api/projects'
import { getAuthStatus, getAuthStatusRework } from '@root/src/api/networkFixer'
import { ModifiedMessageDH, sendMassMail } from '@root/src/api/mailing'
import { getConnectionStatus } from '@root/src/api/connectors/yClients'
import { getActivation } from '@root/src/api/chisai/GCB2'
import ResetArrowIcon from '@/assets/vuetifyIcons/resetArrow.vue'
import SpinArrowsIcon from '@/assets/vuetifyIcons/spinArrows.vue'
import StapleIcon from '@/assets/vuetifyIcons/staple.vue'
import CloseIcon from '@/assets/vuetifyIcons/close.vue'
import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'
import first from 'lodash/first'
import config from '@root/config'
import { watch } from 'vue'
import SendMessageDialog from '@root/src/components/chisai/GCB2/taskList/SendMessageDialog.vue'
export default defineComponent({
    components: { NoOneSelected, Message, HintIcon, ResetArrowIcon, StapleIcon, SpinArrowsIcon, CloseIcon, SendMessageDialog },
    setup(props, {}) {
        const root = getCurrentInstance()!.proxy
        const project = computed<Project>(() =>
            root.$store.getters.projectById(root.$router.currentRoute.params.id)
        )
        const { user } = useUser()
        const taskListBatchModeStore = useTaskListBatchModeStore()
        const hintStore = useHintStore()
        const confirmStore = useConfirmStore()
        const actionLoading = ref(false)
        const { closeSidebar, setBatchModeStatus } = useGcb2Store()
        const modalStore = useModalStore()
        // @ts-ignore И хотелось бы у кого ему научиться
        const {
            selectedCommunications,
            selectedCommunicationsBeforeChange,
        }: {
            selectedCommunications: Ref<ManualCommunication[]>
            selectedCommunicationsBeforeChange: Ref<ManualCommunication[]>
        } = storeToRefs(taskListBatchModeStore)
        const firstActivation = ref<Activation | null>(null)
        const batchModeSettings = ref<any | null>(null)
        
        const staticWrapperHeight = ref('0px')
        const hintId = 'knowledgeBase:1037'
        const allMediaLoading = ref(false)
        const allowedMimeTypes = ref(['image/png', 'image/jpeg', 'application/pdf', 'video/mp4'])
        const isAllUpdate = ref(true)
        const someMediaLoading = ref(false)
        const maxFileSize = ref(20 * 1024 * 1024)
        const isMediaSettingsOpened = ref(false)
        const counterText = computed(
            () =>
                `Выбрано:${selectedCommunications.value.length}, осталось ${messageLimit.value -
                    selectedCommunications.value.length}`
        )

        const changedMessagesCommunicationIds = new Set()

        const waBtnDisabled = computed(() => {
            const connectors = project.value.connectors
            const oldBot = connectors.find(connectors => connectors.connectorType === 'whatsapp')
            const newBot = connectors.find(connectors => connectors.connectorType === 'whatsappBasis')
            const yCLients = connectors.find(connectors => connectors.connectorType === 'yClients')
            if (!oldBot && !newBot &&(!yCLients && config.botYcAvailable.includes(project.value.id))) {
                return true
            }
            return false
        })

        const emptyListErrorMessage = computed(() =>
            !selectedCommunications.value.length ? 'Пользователи не выбраны' : false
        )
        const emptyTextMessageError = computed(() =>
            selectedCommunications.value.some(item => !item.textMessage || !item.textMessage.trim())
                ? 'Одно из сообщений является пустым'
                : false
        )
        const loadingMedia = computed(() => {
            if (allMediaLoading.value || someMediaLoading.value) {
                return 'Дождитесь полной загрузки файлов'
            }
        })
        const setSomeMediaLoading = (value: boolean) => {
            someMediaLoading.value = value
        }
        const toShortPhoneError = computed(() =>
            selectedCommunications.value.some(
                item =>
                    item.hrefInfo
                        .filter(el => {
                            return el.connectorType === 'tel'
                        })[0]
                        .phone.replace(/\D/g, '').length < 11
            )
                ? 'Один из номеров телефонов длиной меньше 11 цифр'
                : false
        )

        const waDisabledError = computed(() => (waBtnDisabled.value ? 'Бот Whatsapp отключен' : false))

        const buttonsDisabled = computed(
            () =>
                emptyListErrorMessage.value ||
                (project.value.isChannelsRework ? false : waDisabledError.value) ||
                emptyTextMessageError.value ||
                isCommunicationUpdate.value ||
                loadingMedia.value
        )
        const isCommunicationUpdate = computed(() =>
            root.$store.getters.isCommunicationUpdate ? 'Дождитесь обновления расчетов' : false
        )
        const messagingConnector = computed(() =>
            taskListBatchModeStore.getMessagingConnector(project.value.id)
        )
        const defaultDailyMessageLimit = computed(
            () => batchModeSettings.value?.default_daily_limit_of_messages_items || 0
        )
        const defaultDailyMessageLimitText = computed(
            () =>
                `${defaultDailyMessageLimit.value} ${declOfNum(defaultDailyMessageLimit.value, [
                    'сообщение',
                    'сообщения',
                    'сообщений',
                ])}`
        )
        const activationSettingsLink = computed(
            () =>
                `/project/${project.value.id}/GCB2/activation?mode=edit&activationId=${firstActivation.value?.id}&highlightedStepId=7`
        )
        const activationListIds = computed(() => {
            const idsList = [] as any[]
            selectedCommunications.value.forEach(el => idsList.push(el.activationId))
            const idsListSet = new Set(idsList)
            return Array.from(idsListSet)
        })
        const openAddDailyLimitModal = () => {
            taskListBatchModeStore.setAddDailyLimitModalOpened(true)
        }
        const openHintSidebar = () => {
            hintStore.openHintSidebar(hintId)
        }
        const messageLimit = computed(() => taskListBatchModeStore.messageLimit(project.value.id))

        const onMessageChanged = (communicationId: number) => {
            changedMessagesCommunicationIds.add(communicationId)
        }
        const saveMessages = async () => {
            actionLoading.value = true
            const changedMessages = selectedCommunications.value.filter(el =>
                changedMessagesCommunicationIds.has(el.communicationId)
            )
            try {
                await actions.batchChangeTextMessage(
                    root,
                    project.value.id,
                    changedMessages.map(el => ({
                        projectId: project.value.id,
                        communicationId: el.communicationId,
                        textMessage: el.textMessage,
                    }))
                )
            } catch (err) {
                console.error(err)
            } finally {
                actionLoading.value = false
            }
        }
        const sendMessages = async () => {
            // Отдельная ветка для isChannelsRework
            if (project.value.isChannelsRework) {
                // const channelConnectorsMap = new Map<string, { connectorId: string; channelId: string }>()
                
                // try {
                //     for (const el of activationListIds.value) {
                //         const { data, error } = await getActivation({
                //             projectId: project.value.id,
                //             id: el,
                //         })

                //         if (!error && data.extra?.sendingSettings) {
                //             const sendingSettings = data.extra.sendingSettings
                //             // Пропускаем cascade и случаи без id
                //             if (sendingSettings?.type === 'cascade' || !sendingSettings.id) {
                //                 continue
                //             }
                            
                //             const channelId = String(sendingSettings.id)
                //             // Находим коннектор по channelId
                //             const channelConnector = project.value.connectors.find(
                //                 connector => String(connector.channelId || connector.connectorId) === channelId
                //             )
                            
                //             if (channelConnector) {
                //                 // Сохраняем уникальные коннекторы
                //                 if (!channelConnectorsMap.has(channelId)) {
                //                     channelConnectorsMap.set(channelId, {
                //                         connectorId: channelConnector.connectorId,
                //                         channelId: channelId,
                //                     })
                //                 }
                //             }
                //         }
                //     }
                    
                //     // Проверяем авторизацию для каждого уникального канала
                //     const unauthorizedChannels = [] as any[]
                //     for (const [channelId, channelData] of channelConnectorsMap.entries()) {
                //         const { data, error } = await getAuthStatusRework({ 
                //             connectorId: channelData.connectorId 
                //         })
                        
                //         if (error) {
                //             // При ошибке показываем уведомление и прерываем
                //             root.$store.dispatch('callNotify', 'Произошла ошибка')
                //             return
                //         }
                        
                //         // Проверяем статус авторизации
                //         const status = data?.status || data?.type || data
                //         const isAuthorized = status === 'authorized' || status === 'alreadyLogged' || data?.authorized === true
                        
                //         if (!isAuthorized) {
                //             unauthorizedChannels.push({
                //                 channelId: channelData.channelId,
                //                 connectorId: channelData.connectorId,
                //             })
                //         }
                //     }
                    
                //     // Если есть неавторизованные каналы, показываем модальное окно
                //     if (unauthorizedChannels.length > 0) {
                //         const firstUnauthorized = unauthorizedChannels[0]
                //         modalStore.open({
                //             text: `Отсутствует авторизация, отправка сообщений невозможна.\nПовторите авторизацию или выберите другой канал в настройках активации.`,
                //             link: [
                //                 `/project/${project.value.id}/connectorSettings/${firstUnauthorized.connectorId}`,
                //             ],
                //             linkText: ['Перейти в настройки канала'],
                //         })
                //         return
                //     }
                    
                //     // Если все каналы авторизованы, переходим к confirmStore.confirm
                confirmStore.confirm({
                    applyText: 'ОТПРАВИТЬ',
                    text: `Вы точно хотите отправить сообщения выбранным (${selectedCommunications.value.length}) клиентам?`,
                    onConfirm: async () => {
                        actionLoading.value = true
                        try {
                            // Используем getMessagesNewSchema если есть ключ isChannelsRework
                            const getMessagesMethod = project.value.isChannelsRework
                                ? messsages.getMessagesNewSchema
                                : messsages.getMessages
                            const messages = getMessagesMethod({
                                projectId: project.value.id,
                                connectors: checkConnectors(project.value.connectors!),
                                communications: selectedCommunications.value,
                                project: project.value,
                                userId: user.value.sub,
                            })

                            let msgCopy: ModifiedMessageDH[] = JSON.parse(JSON.stringify(messages))

                            msgCopy = msgCopy.map(message => {
                                message.messages = message.messages.map(subMessage => {
                                    let activationId = selectedCommunications.value.find(communication => {
                                        return communication.communicationId === subMessage.communicationId
                                    }).activationId
                                    let activationMedia = selectedCommunications.value.find(communication => {
                                        return communication.communicationId === subMessage.communicationId
                                    }).activationMedia
                                    return {
                                        ...subMessage,
                                        activationId,
                                        media: activationMedia
                                    }
                                })
                                return message
                            })
                            let sendMessageResponse = { error: null, data: null } as any

                            sendMessageResponse = await sendMassMail(
                                Object.assign({}, msgCopy[0], { sendAfterCommUpdate: true }) as any
                            )
                            const invalidMessages = sendMessageResponse.data.invalidMessages
                            const validMessages = sendMessageResponse.data.validMessages
                            // Уже стоят в очереди на отправку: сервер их пропустил, статус не трогаем.
                            const duplicateMessages = sendMessageResponse.data.duplicateMessages ?? []
                            if (duplicateMessages.length) {
                                root.$store.dispatch(
                                    'callNotify',
                                    `Уже в очереди на отправку, повторно не отправлено: ${duplicateMessages.length}`
                                )
                            }
                            const invalidSelectedCommunicationsIds = invalidMessages.map(
                                item => item.message.communicationId
                            )
                            const validSelectedCommunicationsIds = validMessages.map(
                                item => item.communicationId
                            )
                            const invalidSelectedCommunications = selectedCommunications.value.filter(item =>
                                invalidSelectedCommunicationsIds.includes(item.communicationId)
                            )
                            const validSelectedCommunications = selectedCommunications.value.filter(item =>
                                validSelectedCommunicationsIds.includes(item.communicationId)
                            )
                            const promises = []
                            if (sendMessageResponse.error || invalidMessages.length) {
                                promises.push(
                                    actions.batchCommunicationError(
                                        root,
                                        project.value.id,
                                        invalidSelectedCommunications.map(el => ({
                                            projectId: project.value.id,
                                            communicationId: el.communicationId,
                                            clientId: el.clientId,
                                            userId: user.value.sub,
                                            userName: user.value.name,
                                            email: user.value.email,
                                            textMessage: el.textMessage,
                                            activationMedia: el.activationMedia,
                                            commType: TASKLIST_COMMUNICATIONS_TYPES.MESSAGE,
                                            messageError: true,
                                            messageErrorCode:
                                                COMMUNICATION_ERROR_CODES[
                                                    invalidMessages.find(
                                                        i => i.message.communicationId === el.communicationId
                                                    ).reason
                                                ],
                                        }))
                                    )
                                )
                            }
                            if (validSelectedCommunications.length) {
                                promises.push(
                                    actions.batchInProgress(
                                        root,
                                        project.value.id,
                                        validSelectedCommunications.map(el => ({
                                            projectId: project.value.id,
                                            communicationId: el.communicationId,
                                            clientId: el.clientId,
                                            userId: user.value.sub,
                                            userName: user.value.name,
                                            email: user.value.email,
                                            textMessage: el.textMessage,
                                            media: el.activationMedia,
                                            commType: TASKLIST_COMMUNICATIONS_TYPES.MESSAGE,
                                            sendAfterCommUpdate: true,
                                        }))
                                    )
                                )
                            }
                            await Promise.all(promises)
                            await taskListBatchModeStore.consumeMessageLimit(
                                project.value.id,
                                validSelectedCommunications.length
                            )
                            if (invalidMessages.length) {
                                root.$store.commit(`GCB2/${t.APPEND_MESSAGE_ERRORS}`, invalidMessages)
                            }
                            if (sendMessageResponse.error) {
                                new ImportantError('batch mode send messages error', {
                                    payload: { error: JSON.stringify(sendMessageResponse.error) },
                                })
                                actionLoading.value = false
                                return
                            }
                        } catch (err) {
                            console.error(err)
                        } finally {
                            actionLoading.value = false
                            closeSidebar()
                            selectedCommunications.value = []
                            localStorage.setItem('pkgStatus', '')
                            return
                        }
                    },
                })
                //     return
                // } catch (err) {
                //     console.error(err)
                //     root.$store.dispatch('callNotify', 'Произошла ошибка')
                //     return
                // }
                return
            }
            
            // Старая логика для случая без isChannelsRework
            let preferedBotInActivationList = [] as any[]
            let oldBotDataFromRequest = null as any
            let newBotDataFromRequest = null as any
            let yClientsConnectorFromRequest = null as any
            const oldBotInConnectors = project.value.connectors.find(
                connector => connector.connectorType === 'whatsapp'
            )
            const newBotInConnectors = project.value.connectors.find(
                connector => connector.connectorType === 'whatsappBasis'
            )
            const yClientsConnector = project.value.connectors.find(
                connector => connector.connectorType === 'yClients'
            )
            const isYcBotAvailable = config.botYcAvailable.includes(project.value.id)
            try {
                for (const el of activationListIds.value) {
                    const { data, error } = await getActivation({
                        projectId: project.value.id,
                        id: el,
                    })

                    if (!error && data.extra?.preferedBot) {
                        preferedBotInActivationList.push({
                            activationId: data.id,
                            activationName: data.name,
                            preferedBot: data.extra?.preferedBot?.split('_')[1] || null,
                        })
                    }
                }
                if (newBotInConnectors) {
                    const { data, error } = await getAuthStatus({
                        connectorId: newBotInConnectors.connectorId,
                    })
                    if (!error) {
                        newBotDataFromRequest = data
                    }
                }
                if (oldBotInConnectors) {
                    const { data, error } = await fetchConnector(oldBotInConnectors.connectorId)
                    if (!error) {
                        oldBotDataFromRequest = data
                    }
                }
                if (yClientsConnector && isYcBotAvailable) {
                    const { data, error } = await getConnectionStatus(yClientsConnector.connectorId)
                    if (!error) {
                        yClientsConnectorFromRequest = data
                    }
                }
            } catch (err) {
                console.error(err)
            }

            if (
                (preferedBotInActivationList.some(el => el.preferedBot === 'whatsappBasis') &&
                    newBotDataFromRequest?.alive !== 'auth') ||
                (preferedBotInActivationList.every(el => el.preferedBot === null) &&
                    newBotInConnectors &&
                    newBotDataFromRequest?.alive !== 'auth' &&
                    !oldBotInConnectors) ||
                (preferedBotInActivationList.every(el => el.preferedBot === null) &&
                    newBotInConnectors &&
                    oldBotInConnectors &&
                    !oldBotDataFromRequest?.alive &&
                    newBotDataFromRequest?.alive !== 'auth')
            ) {
                modalStore.open({
                    text: `Отсутствует авторизация, отправка сообщений невозможна.\nПовторите авторизацию или выберите другого бота в настройках активации.`,
                    link: [
                        `/project/${project.value.id}/connectorSettings/${newBotInConnectors?.connectorId}`,
                    ],
                    linkText: ['Перейти в настройки бота'],
                })
            } else if (
                (preferedBotInActivationList.some(el => el.preferedBot === 'whatsapp') &&
                    !oldBotDataFromRequest?.alive) ||
                (preferedBotInActivationList.every(el => el.preferedBot === null) &&
                    oldBotInConnectors &&
                    !oldBotDataFromRequest?.alive &&
                    !newBotInConnectors)
            ) {
                modalStore.open({
                    text: `Отсутствует авторизация, отправка сообщений невозможна.\nПовторите авторизацию или выберите другого бота в настройках активации.`,
                    link: [
                        `/project/${project.value.id}/connectorSettings/${oldBotInConnectors?.connectorId}`,
                    ],
                    linkText: ['Перейти в настройки бота'],
                })
            } else if (
                ((preferedBotInActivationList.some(el => el.preferedBot === 'yClients') &&
                    yClientsConnectorFromRequest?.status !== 'active') ||
                (preferedBotInActivationList.every(el => el.preferedBot === null) &&
                    !oldBotInConnectors &&
                    !newBotInConnectors &&
                    yClientsConnector)) && isYcBotAvailable
            ) {
                modalStore.open({
                    text: `Отсутствует авторизация, отправка сообщений невозможна.\nОбратитесь, пожалуйста, к своему боту.`,
                })
            } else if (preferedBotInActivationList.some(el => el.preferedBot === 'yClients') && !isYcBotAvailable) {
                modalStore.open({
                    text: `Отправка через бота yClients невозможна.\nВыберите, пожалуйста, другого бота.`,
                })
            } else {
                confirmStore.confirm({
                    applyText: 'ОТПРАВИТЬ',
                    text: `Вы точно хотите отправить сообщения выбранным (${selectedCommunications.value.length}) клиентам?`,
                    onConfirm: async () => {
                        actionLoading.value = true
                        try {
                            // Используем getMessagesNewSchema если есть ключ isChannelsRework
                            const getMessagesMethod = project.value.isChannelsRework
                                ? messsages.getMessagesNewSchema
                                : messsages.getMessages
                            const messages = getMessagesMethod({
                                projectId: project.value.id,
                                connectors: checkConnectors(project.value.connectors!),
                                communications: selectedCommunications.value,
                                project: project.value,
                                userId: user.value.sub,
                            })

                            let msgCopy: ModifiedMessageDH[] = JSON.parse(JSON.stringify(messages))

                            msgCopy = msgCopy.map(message => {
                                message.messages = message.messages.map(subMessage => {
                                    let activationId = selectedCommunications.value.find(communication => {
                                        return communication.communicationId === subMessage.communicationId
                                    }).activationId
                                    let activationMedia = selectedCommunications.value.find(communication => {
                                        return communication.communicationId === subMessage.communicationId
                                    }).activationMedia
                                    return {
                                        ...subMessage,
                                        activationId,
                                        media: activationMedia
                                    }
                                })
                                return message
                            })
                            let sendMessageResponse = { error: null, data: null } as any

                            sendMessageResponse = await sendMassMail(
                                Object.assign({}, msgCopy[0], { sendAfterCommUpdate: true }) as any
                            )
                            const invalidMessages = sendMessageResponse.data.invalidMessages
                            const validMessages = sendMessageResponse.data.validMessages
                            // Уже стоят в очереди на отправку: сервер их пропустил, статус не трогаем.
                            const duplicateMessages = sendMessageResponse.data.duplicateMessages ?? []
                            if (duplicateMessages.length) {
                                root.$store.dispatch(
                                    'callNotify',
                                    `Уже в очереди на отправку, повторно не отправлено: ${duplicateMessages.length}`
                                )
                            }
                            const invalidSelectedCommunicationsIds = invalidMessages.map(
                                item => item.message.communicationId
                            )
                            const validSelectedCommunicationsIds = validMessages.map(
                                item => item.communicationId
                            )
                            const invalidSelectedCommunications = selectedCommunications.value.filter(item =>
                                invalidSelectedCommunicationsIds.includes(item.communicationId)
                            )
                            const validSelectedCommunications = selectedCommunications.value.filter(item =>
                                validSelectedCommunicationsIds.includes(item.communicationId)
                            )
                            const promises = []
                            if (sendMessageResponse.error || invalidMessages.length) {
                                promises.push(
                                    actions.batchCommunicationError(
                                        root,
                                        project.value.id,
                                        invalidSelectedCommunications.map(el => ({
                                            projectId: project.value.id,
                                            communicationId: el.communicationId,
                                            clientId: el.clientId,
                                            userId: user.value.sub,
                                            userName: user.value.name,
                                            email: user.value.email,
                                            textMessage: el.textMessage,
                                            activationMedia: el.activationMedia,
                                            commType: TASKLIST_COMMUNICATIONS_TYPES.MESSAGE,
                                            messageError: true,
                                            messageErrorCode:
                                                COMMUNICATION_ERROR_CODES[
                                                    invalidMessages.find(
                                                        i => i.message.communicationId === el.communicationId
                                                    ).reason
                                                ],
                                        }))
                                    )
                                )
                            }
                            if (validSelectedCommunications.length) {
                                promises.push(
                                    actions.batchInProgress(
                                        root,
                                        project.value.id,
                                        validSelectedCommunications.map(el => ({
                                            projectId: project.value.id,
                                            communicationId: el.communicationId,
                                            clientId: el.clientId,
                                            userId: user.value.sub,
                                            userName: user.value.name,
                                            email: user.value.email,
                                            textMessage: el.textMessage,
                                            media: el.activationMedia,
                                            commType: TASKLIST_COMMUNICATIONS_TYPES.MESSAGE,
                                            sendAfterCommUpdate: true,
                                        }))
                                    )
                                )
                            }
                            await Promise.all(promises)
                            await taskListBatchModeStore.consumeMessageLimit(
                                project.value.id,
                                validSelectedCommunications.length
                            )
                            if (invalidMessages.length) {
                                root.$store.commit(`GCB2/${t.APPEND_MESSAGE_ERRORS}`, invalidMessages)
                            }
                            if (sendMessageResponse.error) {
                                new ImportantError('batch mode send messages error', {
                                    payload: { error: JSON.stringify(sendMessageResponse.error) },
                                })
                                actionLoading.value = false
                                return
                            }
                        } catch (err) {
                            console.error(err)
                        } finally {
                            actionLoading.value = false
                            closeSidebar()
                            selectedCommunications.value = []
                            localStorage.setItem('pkgStatus', '')
                        }
                    },
                })
            }
        }
        const onClickOutside = () => {
            isMediaSettingsOpened.value = false
        }
        const disabledReset = computed(() => {
            if (allMediaLoading.value || someMediaLoading.value) return true;
            
            // Функция для нормализации объектов перед сравнением
            const normalizeItem = (item: ManualCommunication) => {
                const copy = cloneDeep(item);
                if (copy.activationMedia === null) {
                    delete copy.activationMedia;
                }
                return copy;
            };

            const current = selectedCommunications.value.map(normalizeItem);
            const before = selectedCommunicationsBeforeChange.value.map(normalizeItem);

            return isEqual(current, before);
        })
        const resetChange = () => {
            selectedCommunications.value = cloneDeep(selectedCommunicationsBeforeChange.value)
        }
        const uploadFile = async (files: File[] | FileList | null) => {
            isMediaSettingsOpened.value = false
            if (!files) return
            allMediaLoading.value = true
            const file = first<File>(files as any)
            if (!allowedMimeTypes.value.includes(file?.type!)) {
                root.$store.dispatch('callNotify', 'Не верный формат файла')
                allMediaLoading.value = false
                return
            }

            if (file && file?.size > maxFileSize.value) {
                root.$store.dispatch('callNotify', 'Превышен максимальный размер файла')
                clearFile()
                allMediaLoading.value = false
                return
            }
            const { data, error } = await api.file.uploadMedia({ projectId: project.value.id, file: file! })
            if (error) {
                root.$store.dispatch('callNotify', 'Произошла ошибка при загрузке файла')
                allMediaLoading.value = false
                return
            }
            update(data!.url)
            if (file?.type.startsWith('video/')) {
                await generateVideoThumbnail(file!, data!.url)
            }
            allMediaLoading.value = false
        }
        const update = (v: any | null) => {
        if (!isAllUpdate.value) {
            // Заменяем медиа у ВСЕХ элементов, где activationMedia !== null
            selectedCommunications.value = selectedCommunications.value.map(el => {
                if (el.activationMedia) {
                        return { ...el, activationMedia: cloneDeep(v) }
                }
                return el
            })
        } else {
            // Добавляем медиа ко ВСЕМ элементам
            selectedCommunications.value = selectedCommunications.value.map(el => ({
                ...el,
                    activationMedia: cloneDeep(v)
            }))
        }
    }
        const generateVideoThumbnail = (file: File, item) => {
            return new Promise(resolve => {
                const video = document.createElement('video')
                const canvas = document.createElement('canvas')
                const url = URL.createObjectURL(file)

                video.src = url
                video.addEventListener('loadeddata', async () => {
                    video.currentTime = 1 // Берем кадр на 1-й секунде
                }, { once: true })

                video.addEventListener('seeked', () => {
                    canvas.width = video.videoWidth
                    canvas.height = video.videoHeight
                    const ctx = canvas.getContext('2d')!
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

                    canvas.toBlob(async blob => {
                        const thumbFile = new File([blob!], 'thumbnail.png', { type: 'image/png' })
                        const { data } = await api.file.uploadMedia({
                            projectId: project.value.id,
                            file: thumbFile,
                        })

                        update({
                            ...(item || {}),
                            thumbnail: data!.url,
                        })

                        URL.revokeObjectURL(url)
                        resolve(true)
                    }, 'image/png')
                }, { once: true })
            })
        }
        const clearFile = () => {
            update(null)
        }
        const onInputChange = (e: Event) => {
            const target = e.target as HTMLInputElement
            const files = target.files!
            uploadFile(files)
        }
        const openUploadWindow = isAll => {
            isAllUpdate.value = isAll
            const fileInput = root.$refs['fileInputAll'] as HTMLInputElement
            fileInput.click()
        }
        const disabledMediaButton = computed(() => {
            return selectedCommunications.value.length < 1 || someMediaLoading.value || allMediaLoading.value
        })
        const disabledAddAll = computed(() => {
            return (allMediaLoading.value || selectedCommunications.value.some(el => el.activationMedia))
        })
        const disabledResetAllMedia = computed(() => {
            return (allMediaLoading.value || selectedCommunications.value.every(el => !el.activationMedia))
        })
        const key = ref(1)
        const resetAllMedia = () => {
            selectedCommunications.value = selectedCommunications.value.map(el => ({
                ...el,
                activationMedia: null
            }));
            key.value++;
            isMediaSettingsOpened.value = false;
        }
        const activeItem = ref(null)
        const isSendMessageDialog = ref(false)
        const openSendMessageDialog = (item: any) => {
            activeItem.value = item
            isSendMessageDialog.value = true
        }
        watch(
            () => isSendMessageDialog.value,
            newValue => {
                if(!newValue) {
                    key.value++;
                }
            }
        )
        const setNextItem = (item: ManualCommunication) => {
            const nextIndex = selectedCommunications.value.indexOf(item) + 1
            activeItem.value = selectedCommunications.value[nextIndex]
        }
        const setPrewItem = (item: ManualCommunication) => {
            const prewIndex = selectedCommunications.value.indexOf(item) - 1
            activeItem.value = selectedCommunications.value[prewIndex]
        }
        const currentItemPlace = computed(() => {
            return selectedCommunications.value.indexOf(activeItem.value) + 1
        })
        const selectedCommunicationsLength = computed(() => {
            return selectedCommunications.value.length
        })

        onMounted(async () => {
            staticWrapperHeight.value = String(+(root.$refs['static-header'] as any).clientHeight + 50) + 'px'
            const [_firstActivation, _batchModeSettings] = await Promise.all([
                api.gcb2.getFirstActivation(project.value.id).then(res => res.data!),
                api.massender
                    .getLimitSettings({
                        projectId: project.value.id,
                        connectorType: messagingConnector.value?.connectorType!,
                    })
                    .then(res => res.data!),
                taskListBatchModeStore.fetchSendMessageLimit(project.value.id),
            ])
            firstActivation.value = _firstActivation
            batchModeSettings.value = _batchModeSettings
        })

        return {
            selectedCommunications,
            selectedCommunicationsBeforeChange,
            counterText,
            buttonsDisabled,
            actionLoading,
            closeSidebar,
            defaultDailyMessageLimitText,
            sendMessages,
            onMessageChanged,
            saveMessages,
            messageLimit,
            staticWrapperHeight,
            openAddDailyLimitModal,
            defaultDailyMessageLimit,
            activationSettingsLink,
            hintId,
            openHintSidebar,
            emptyListErrorMessage,
            emptyTextMessageError,
            toShortPhoneError,
            isCommunicationUpdate,
            resetChange,
            disabledReset,
            allMediaLoading,
            allowedMimeTypes,
            onInputChange,
            openUploadWindow,
            disabledAddAll,
            disabledResetAllMedia,
            resetAllMedia,
            disabledMediaButton,
            isMediaSettingsOpened,
            onClickOutside,
            activeItem,
            isSendMessageDialog,
            openSendMessageDialog,
            selectedCommunicationsLength,
            setPrewItem,
            setNextItem,
            currentItemPlace,
            someMediaLoading,
            setSomeMediaLoading,
            key
        }
    },
})
